import React from 'react';
import { Typography, Button, Banner } from '@scale/scaleui';
import SelectTag from 'react-scale/corp/components/UI/SelectTag';

interface GlobalTagsPermissionsBuilderProps {
  useTagFilters: boolean;
  setUseTagFilters: (useTagFilters: boolean) => void;
  excludeTagsSelect?: { label: string; value: string }[];
  setExcludeTagsSelect: (excludeTagsSelect: { label: string; value: string }[]) => void;
  requireTagsSelect?: { label: string; value: string }[];
  setRequireTagsSelect: (requireTagsSelect: { label: string; value: string }[]) => void;
}

const PaddedParagraph = ({ paragraph }: { paragraph: string }) => {
  return (
    <div className="mt-4 mb-2">
      <Typography.Paragraph1>{paragraph}</Typography.Paragraph1>
    </div>
  );
};

const GlobalTagsPermissionsBuilder: React.FC<GlobalTagsPermissionsBuilderProps> = ({
  useTagFilters,
  setUseTagFilters,
  excludeTagsSelect,
  setExcludeTagsSelect,
  requireTagsSelect,
  setRequireTagsSelect,
}) => {
  return (
    <div>
      {useTagFilters ? (
        <div>
          <PaddedParagraph paragraph="Require These Tags" />
          <SelectTag
            multi
            fullWidth
            isClearable
            ignoreCase
            value={requireTagsSelect}
            onChange={(value: any) => setRequireTagsSelect(value)}
            placeholder="Required Worker Tags"
          />
          <PaddedParagraph paragraph="Exclude These Tags" />
          <SelectTag
            multi
            fullWidth
            isClearable
            ignoreCase
            value={excludeTagsSelect}
            onChange={(value: any) => setExcludeTagsSelect(value)}
            placeholder="Excluded Worker Tags"
          />
          <Banner
            className="mb-2 mt-4"
            title="Global Tag Filters"
            subtitle="We don't recommend using tag filters unless you absolutely have to prioritize via worker tags. Requiring tag filters will also significantly increase load time for the Tasker Screening Grading table."
            variant="danger"
            background="neutral"
          />
        </div>
      ) : (
        <Button variant="secondary" onClick={() => setUseTagFilters(true)}>
          Use Global Tag Filters
        </Button>
      )}
    </div>
  );
};

export default GlobalTagsPermissionsBuilder;
